import { useEffect, useState } from 'react'
import { useFlags, useFlagsmith } from 'flagsmith/react'
import { getFlagsmithAPIKey } from '../constants'

const generateFlagsmithIdentity = ({ flagsmithEnv, userId }) => `${flagsmithEnv}_admin_${userId}`

const generateStudyIdTrait = (flagsmithEnv, studyId) => `${flagsmithEnv}_${studyId || 'no_study'}`

const useFlagsmithFeature = ({ featureFlags = {}, studyId = '', userId }) => {

  const flagsmithEnv = getFlagsmithAPIKey()
  const flagsmith = useFlagsmith()
  const [flagsmithErr, setFlagsmithErr] = useState(null)

  useEffect(() => {
    const studyIdTrait = generateStudyIdTrait(flagsmithEnv, studyId)
    flagsmith.setTrait('study_id', studyIdTrait)
  }, [studyId])

  useEffect(() => {
    if (!userId || !flagsmithEnv) return

    const identity = generateFlagsmithIdentity({ flagsmithEnv, userId })

    const onFlagsmithError = e => setFlagsmithErr(e)

    flagsmith.onError = onFlagsmithError
    flagsmith.identify(identity)

    return () => {
      flagsmith.onError = null // Clean up
    }
  }, [userId, flagsmithEnv])

  const flagsArr = Object.keys(featureFlags).map(flag => {
    return [flag]
  })
  /**
   * If there is an error with Flagsmith, return what was passed as the default
   * flags as a parameter.
   */
  const features = useFlags(...flagsArr)
  if (flagsmithErr || !flagsmithEnv || !userId) return featureFlags
  return features
}

export default useFlagsmithFeature
